// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__xZXSO","detailsBorder":"styles_detailsBorder__3UsKm"};